<div class="loader-div" *ngIf="shared.spinner">
  <div class="gif-div">
    <div class="spinner-border text-danger" role="status">
      <span class="visually-hidden">{{ "common.loading" | translate }}</span>
    </div>
  </div>
</div>